module.exports = __webpack_public_path__ + "img/Tech_analyse_bio_01_TPO.5825f17d.jpg";